import React, { useState } from 'react';

import Loader from 'react-loader-spinner';
import { NavLink, useParams, withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faTrash } from '@fortawesome/free-solid-svg-icons';
import { withFirebase } from '../firebase';
import Modal from 'react-modal';
import { modalStyle } from '../styles/modal';
import * as ROUTES from '../../constants/routes';
import ModalConfirm from '../useful/ModalConfirm';


const TeamListItem = (props) => {

    const { tournament_uid } = useParams(); // tournament uid
    const userId = props.firebase.auth.currentUser.uid; // user auth uid

    const { item, index, disabled } = props;
    const [deleting, setDeleting] = useState(false);
    const [confirmModal, setConfirmModal] = useState({ show: false, title: '', message: '' });

    const deleteItem = () => {
        if (!disabled) {
            setConfirmModal({ show: false, title: '', message: '' });
            // setDeleting(true);
            props.firebase.teamDoc(userId, tournament_uid, item.uid).delete()
                .then(() => {
                    setDeleting(false);
                    // props.showModal("Info", "El equipo se eliminó con éxito");
                })
                .catch((error) => {
                    console.log("Error: ", error);
                    setDeleting(false);
                    props.showModal("Error", "No se pudo eliminar el equipo: " + item.title);
                });
        }
    }

    const showConfirmModal = () => {
        setConfirmModal({ show: true, title: 'Eliminar equipo', message: 'Está seguro de eliminar el equipo: ' + item.title });
    }

    const openTeam = () => {
        props.history.push(ROUTES.TOURNAMENT_TEAM(tournament_uid, item.uid))
    }

    const teamLogo = (item && item.logoUrl) ? item.logoUrl : process.env.PUBLIC_URL + "/team_logo.png"
    const playerUidList = JSON.parse(item.players || "[]")
    const playersCount = playerUidList instanceof Array ? playerUidList.length : 0

    return (
        <tr className="bg-hover-td">
            {/* <td className="align-middle text-center" onClick={openTeam} scope="row" >{index}</td> */}
            <td className="align-middle text-right" onClick={openTeam} >
                <div style={{
                    backgroundImage: `url(${teamLogo})`,
                    height: 30,
                    width: 30,
                    minWidth: 30,
                    backgroundPosition: 'center',
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat'
                }} />
            </td>
            <td className="align-middle" onClick={openTeam} >{item.title}</td>
            <td className="align-middle text-center" onClick={openTeam} >{playersCount}</td>
            <th className="align-middle">
                <div className="nav justify-content-end">
                    {(!deleting) ?
                        <button disabled={disabled} onClick={showConfirmModal} className="btn btn btn-link text-danger" data-toggle="tooltip" data-placement="bottom" title="Eliminar">
                            <FontAwesomeIcon icon={faTrashAlt} />
                        </button>
                        :
                        <Loader className="m-1"
                            type="ThreeDots"
                            color="#263238"
                            height={30}
                            width={40}
                            timeout={0} />
                    }
                </div>
            </th>

            <ModalConfirm
                data={confirmModal}
                onClose={() => setConfirmModal({ show: false, title: '', message: '' })}
                onConfirm={deleteItem}
            />

        </tr >
    )


}

export default withRouter(withFirebase(TeamListItem));
